import { createContext, useState, useCallback, useMemo } from "react";
import { SelectModel } from "../../../types/SelectModel";
import LoaderScreen from "../../../../components/loaders/LoaderScreen";

export const UserContext = createContext<any>(null);

export const UserProvider = (props: any) => {
  const [tokenUser, setTokenUser] = useState<string | null>(() => {  return localStorage.getItem("token_session"); });
  const [ruta, setRuta] = useState<string | null>(() => { return localStorage.getItem("ruta"); });
  const [imageFondo, setImageFondo] = useState<string | null>(() => {   return localStorage.getItem("Fondo_ImageUrl"); }); // Carga desde localStorage
  const [loadingCount, setLoadingCount] = useState(0); 
  const loading = loadingCount > 0;
  
  const [selectLocales, setSelectLocales] = useState<SelectModel[]>(() => {
    // Verifica si hay datos en localStorage y parsea el JSON, de lo contrario, usa un array vacío
    const savedLocales = localStorage.getItem("selectLocales");    
    return savedLocales ? JSON.parse(savedLocales) : []; 
  });

  const [tipoCambio, setTipoCambio] = useState<number>(() => {
    const tipoCambioStored = localStorage.getItem("tipo_cambio");
    // Si el valor existe en localStorage, lo convertimos a número. Si no, asignamos un valor predeterminado (por ejemplo, 1)
    return tipoCambioStored ? parseFloat(tipoCambioStored) : 0; 
  });

  // Función para actualizar la imagen de fondo
  const setImageUrl = useCallback((url: string) => {
    localStorage.setItem("Fondo_ImageUrl", url);
    setImageFondo(url);
  }, []);

  const idTokenUser = useCallback((token: string) => {
    localStorage.setItem("token_session", token);
    setTokenUser(token);
  }, []);

  const idRuta = useCallback((idRuta: any) => {
    localStorage.setItem("ruta", idRuta);
    setRuta(idRuta!);
  }, []);

  //Funcion para cargargar el Loading
  const idLoading = useCallback((val: boolean) => {
    setLoadingCount(prev => val ? prev + 1 : Math.max(0, prev - 1));
  }, []);

  const idSelectLocales = useCallback((idSelectedLocales: any) => {
    localStorage.setItem("selectLocales", JSON.stringify(idSelectedLocales));
    setSelectLocales(idSelectedLocales); 
  }, []);

  const idTipoCambio = useCallback((idTipoCambio: any) => {   
    localStorage.setItem("tipo_cambio", idTipoCambio);
    setTipoCambio(idTipoCambio);
  }, []);

  const contextValue = useMemo(() => ({
    tokenUser,
    idTokenUser,
    ruta,
    idRuta,
    imageFondo,
    setImageUrl,
    idLoading,
    selectLocales,
    idSelectLocales,
    tipoCambio,
    idTipoCambio
  }), [tokenUser, ruta, imageFondo, idLoading, selectLocales, tipoCambio, idTokenUser, idRuta, setImageUrl, idSelectLocales, idTipoCambio]);

  return (
    <UserContext.Provider value={contextValue}>
      {props.children}
      {loading && <LoaderScreen />}
    </UserContext.Provider>
  );
};
